import { world } from '../languages';
import { WORLD_GROUPS } from '../languages/constants';

const isMainWorld = (): boolean => {
    return WORLD_GROUPS.MAIN.includes(world);
};

export default isMainWorld;
